// extracted by css-extract-rspack-plugin
export default {"buttonContainer":"UOEfC0KPlwUGHF29"};